import { useTranslation } from "react-i18next";
import { TimePickerWithLabel } from "web-apps/company/components/general/timePicker/timePickerWithLabel.component";
import { DateContainer } from "web-apps/company/components/gig/gigForm/createGigModal.styled";
import { SettingsSection } from "./settingSection.component";

export const TimeSettings: React.FC<{
  startTime: string;
  endTime: string;
  onChangeStartTime: (v: string) => void;
  onChangeEndTime: (v: string) => void;
}> = ({ startTime, endTime, onChangeStartTime, onChangeEndTime }) => {
  const { t } = useTranslation();
  return (
    <SettingsSection title={t("System.ShiftDefaultTime")} info={t("System.ShiftDefaultTimeInfo")}>
      <DateContainer style={{ marginBottom: 30 }}>
        <TimePickerWithLabel
          label={t("StampClock.StartTime")}
          value={startTime}
          onChange={onChangeStartTime}
        />
        <TimePickerWithLabel
          label={t("StampClock.EndTime")}
          value={endTime}
          onChange={onChangeEndTime}
        />
      </DateContainer>
    </SettingsSection>
  );
};
